import { format } from 'date-fns';
import { toDateOrNull, toIsoDate } from 'seagull/utils/isoDate';
export { toDateOrNull, toIsoDate };
const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const parseYearMonthDay = (value)=>{
    if (!DATE_PATTERN.test(value)) return null;
    const [year, month, day] = value.split('-').map(Number);
    return {
        year,
        month,
        day
    };
};
const toLocalDate = (param)=>{
    let { year, month, day } = param;
    return new Date(year, month - 1, day);
};
const isLeapYear = (year)=>year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
const lastDayOfMonth = (year, month)=>month === 2 && isLeapYear(year) ? 29 : DAYS_IN_MONTH[month - 1];
const formatDay = (value)=>{
    const parsed = parseYearMonthDay(value);
    return parsed == null ? value : format(toLocalDate(parsed), 'MMM d, yyyy');
};
const rangeDisplay = (gte, lte)=>{
    const from = parseYearMonthDay(gte);
    const to = parseYearMonthDay(lte);
    if (from == null || to == null) return {
        label: "".concat(formatDay(gte), " → ").concat(formatDay(lte))
    };
    if (from.year === to.year && from.month === 1 && from.day === 1 && to.month === 12 && to.day === 31) {
        return {
            prefix: 'in',
            label: "".concat(from.year)
        };
    }
    if (from.year === to.year && from.month === to.month && from.day === 1 && to.day === lastDayOfMonth(to.year, to.month)) {
        return {
            prefix: 'in',
            label: format(toLocalDate(from), 'MMMM yyyy')
        };
    }
    return {
        label: "".concat(formatDay(gte), " → ").concat(formatDay(lte))
    };
};
export const isEqMode = (predicate)=>predicate.eq != null || predicate.neq != null;
export const valueLabelFor = (predicate, fieldLabel)=>{
    if (predicate.eq != null) return formatDay(predicate.eq);
    if (predicate.neq != null) return formatDay(predicate.neq);
    if (predicate.gte != null && predicate.lte != null) return rangeDisplay(predicate.gte, predicate.lte).label;
    if (predicate.gte != null) return "≥ ".concat(formatDay(predicate.gte));
    if (predicate.lte != null) return "≤ ".concat(formatDay(predicate.lte));
    return fieldLabel;
};
export const valuePrefixFor = (predicate)=>{
    if (predicate.gte != null && predicate.lte != null) return rangeDisplay(predicate.gte, predicate.lte).prefix;
    return undefined;
};
export const isExactMatch = (predicate)=>predicate.eq != null || predicate.neq != null;
const DAY_MONTH = 'MMM d';
const FULL_DATE = 'MMM d, yyyy';
const DAY_AND_YEAR = 'd, yyyy';
const formatWith = (iso, pattern)=>{
    const date = toDateOrNull(iso);
    return date == null ? iso : format(date, pattern);
};
const yearOf = (iso)=>{
    const date = toDateOrNull(iso);
    return date == null ? null : date.getFullYear();
};
const isSameMonth = (from, to)=>from.getFullYear() === to.getFullYear() && from.getMonth() === to.getMonth();
const sameMonthLabel = (gte, lte)=>{
    const from = toDateOrNull(gte);
    const to = toDateOrNull(lte);
    if (from == null || to == null || !isSameMonth(from, to)) return null;
    if (from.getDate() === to.getDate()) return format(from, FULL_DATE);
    return "".concat(format(from, DAY_MONTH), "-").concat(format(to, DAY_AND_YEAR));
};
export const rangeDateValueLabel = (predicate, fallback)=>{
    if (predicate.eq != null) return formatWith(predicate.eq, FULL_DATE);
    if (predicate.neq != null) return "≠".concat(formatWith(predicate.neq, FULL_DATE));
    if (predicate.gte != null && predicate.lte != null) {
        const sameMonth = sameMonthLabel(predicate.gte, predicate.lte);
        if (sameMonth != null) return sameMonth;
        const sameYear = yearOf(predicate.gte) === yearOf(predicate.lte);
        return sameYear ? "".concat(formatWith(predicate.gte, DAY_MONTH), " – ").concat(formatWith(predicate.lte, FULL_DATE)) : "".concat(formatWith(predicate.gte, FULL_DATE), " – ").concat(formatWith(predicate.lte, FULL_DATE));
    }
    if (predicate.gte != null) return "from ".concat(formatWith(predicate.gte, FULL_DATE));
    if (predicate.lte != null) return "until ".concat(formatWith(predicate.lte, FULL_DATE));
    return fallback;
};
